import React from "react"
import { motion } from "framer-motion"
import { FaHtml5, FaCss3Alt, FaReact, FaNodeJs } from "react-icons/fa"
import { SiJavascript, SiTypescript, SiExpress, SiPostgresql, SiPrisma, SiTailwindcss } from "react-icons/si"

const STACK = [
  { icon: <FaHtml5 />, label: "HTML5" },
  { icon: <FaCss3Alt />, label: "CSS3" },
  { icon: <SiJavascript />, label: "JavaScript" },
  { icon: <SiTypescript />, label: "TypeScript" },
  { icon: <FaReact />, label: "React" },
  { icon: <SiTailwindcss />, label: "Tailwind" },
  { icon: <FaNodeJs />, label: "Node.js" },
  { icon: <SiExpress />, label: "Express" },
  { icon: <SiPostgresql />, label: "PostgreSQL" },
  { icon: <SiPrisma />, label: "Prisma" },
]

export default function TechStack() {
  return (
    <div id="skills" className="max-w-6xl mx-auto px-6 mt-16 pt-10 border-t border-lineSoft">
      <h2 className="font-mono text-xs tracking-widest text-muted2 mb-6">TECH STACK</h2>
      <div className="flex flex-wrap gap-3">
        {STACK.map((t, i) => (
          <motion.div
            key={t.label}
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.35, delay: i * 0.03 }}
            className="flex items-center gap-2 border border-line px-3.5 py-2 text-sm text-muted hover:text-white hover:border-amber transition-colors"
          >
            <span className="text-lg text-amber" aria-hidden="true">
              {t.icon}
            </span>
            {t.label}
          </motion.div>
        ))}
      </div>
    </div>
  )
}
